import React from 'react';
import bg from '../../images/info/historical.png';
import partnership from '../../images/info/partnership.png';

const InfoSection: React.FC = () => {
    return (
        <div className="container flex flex-wrap w-[calc(100%-30px)] mx-auto gap-2" style={{ marginTop: '20px', marginBottom: '48px' }}>
            <div className="flex w-full gap-2 flex-col md:flex-row">
                <div className="md:w-3/4 w-full bg-[#2E2E2E] sm:h-80 h-60 rounded-lg cursor-pointer partnership overflow-hidden" style={{ backgroundImage: `url(${partnership})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                    <div className='relative bg-black bg-opacity-40 w-full h-full flex items-center justify-center'>
                        <h1 className='text-white' style={{ fontSize: '3rem', fontWeight: '400' }}>Partnership?</h1>
                        <button className='absolute bottom-[30px] right-[calc(50%-60px)] bg-[#FAA61A] px-5 py-3 rounded-xl cursror-pointer text-white'>Contact Us</button>
                    </div>
                </div>
                <div className="md:w-1/4 w-full bg-[#2E2E2E] sm:h-80 h-60 rounded-lg flex items-center justify-center relative overflow-hidden cursor-pointer">
                    <div className="absolute inset-0 bg-gray-800 opacity-50 z-40"></div> {/* Gray overlay */}
                    <div className="relative z-10"> {/* Text container with higher z-index */}
                    </div>
                    <div className="absolute z-50">
                        <h2 className="text-[#FAA61A] text-5xl font-bold">
                            OUR <span className="block text-3xl">HISTORY</span>
                        </h2>
                    </div>
                    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${bg})` }}>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoSection;